import React, {useEffect, useMemo, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useLocation} from 'react-router-dom'
import DeleteConfirmationPopup from '../../../../../Components/DeleteConfirmationPopup'
import {GeneralDataOFLoginUser} from '../../../../../Utils/Auth'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'
import {
  GetPriceRuleList,
  UpdateWhiteLabelCommisionRateSuperAdmin,
} from '../../../Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'

const WhiteLabelPriceRule = () => {
  const ProfileDetatileState = useSelector(
    (state: any) => state?.ProfileData?.ProfileData?.items?.[0]
  )
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true
  const Role = GeneralDataOFLoginUser()?.role
  const PriceRateList = useSelector((state: any) => state?.priceRules?.RateCardList)

  const dispatch = useDispatch()
  const [percentage, setPercentage] = useState(ProfileDetatileState?.user?.commissionRate)
  useEffect(() => {
    dispatch(GetPriceRuleList({accountId: ProfileDetatileState?.user?.accountId}))
  }, [])
  const updateComission = () => {
    dispatch(
      UpdateWhiteLabelCommisionRateSuperAdmin({
        id: ProfileDetatileState?._id,
        commission: {
          userId: ProfileDetatileState?.user?._id,
          commissionRate: percentage,
        },
      })
    )
  }

  return (
    <>
      <div className='card mb-0'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>Price Rules</h3>
          </div>
          <div className='card-toolbar m-0'>
            {!isUserWhiteLabel && Role == ('superAdmin' || 'subAdmin') && (
              <div className='d-flex gap-3 align-items-center'>
                <input
                  className='form-control-solid form-control form-control-sm'
                  name='percentage'
                  value={percentage}
                  onChange={(e: any) => setPercentage(e.target.value)}
                />
                <button onClick={updateComission} className='btn btn-primary'>
                  Update
                </button>
              </div>
            )}
          </div>
        </div>
        <div className='card-body pt-2'>
          <div className='tab-content'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted text-uppercase'>
                    <th>Type</th>
                    <th>Credit From</th>
                    <th>Credit TO</th>

                    <th>Final Price</th>
                    <th>Commission</th>
                  </tr>
                </thead>
                <tbody className='text-gray-600'>
                  {PriceRateList?.map((data: any, id: number) => (
                    <tr key={id}>
                      <td>
                        <span className='badge badge-light-info'>{data?.type}</span>
                      </td>
                      <td>{data?.creditstartrange}</td>
                      <td>{data?.creditendrange}</td>

                      <td>${data?.finalPrice}</td>
                      <td>
                        ${' '}
                        {(
                          data?.finalPrice *
                          (ProfileDetatileState?.user?.commissionRate / 100)
                        ).toFixed(4)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default WhiteLabelPriceRule
